import { fromUnixTime } from "date-fns/esm";

import FormFieldViewText from "components/FormFields/ViewText";
import { DataFlow, External } from "components/icons/generated";
import PageLoading from "components/loading/PageLoading";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import Card from "ds/components/Card";
import IconEmphasized from "ds/components/IconEmphasized";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import useTypedContext from "hooks/useTypedContext";
import useTitle from "hooks/useTitle";
import useFlowsIntegration from "shared/Flows/useFlowsIntegration";
import { formatDate } from "utils/date";
import { extractHost } from "utils/urls";
import { AccountContext } from "views/AccountWrapper";

import FlowsSettingsPageLayout from "./PageLayout";

const FlowsSettings = () => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Organization Settings · Flows · ${accountName}`);

  const { flowsIntegration, loading } = useFlowsIntegration();

  if (loading) {
    return <PageLoading />;
  }

  return (
    <FlowsSettingsPageLayout>
      <Box direction="column" limitWidth="medium" fullWidth>
        <Card
          titleTag="h3"
          title="Flows"
          headerPrefix={<IconEmphasized icon={DataFlow} />}
          headerSuffix={
            flowsIntegration ? (
              <LinkButton
                variant="secondary"
                endIcon={External}
                href="/flows/login"
                target="_blank"
              >
                Open Flows
              </LinkButton>
            ) : (
              <LinkButton
                variant="secondary"
                endIcon={External}
                href="/flows/link/select"
                target="_blank"
              >
                Enable Flows Integration
              </LinkButton>
            )
          }
        >
          {flowsIntegration ? (
            <Box direction="column" gap="large" padding="medium 0 0">
              <FormFieldViewText
                label="Instance"
                value={extractHost(flowsIntegration.baseURL)}
                noMargin
              />
              <FormFieldViewText
                label="Organization name"
                value={flowsIntegration.organizationName}
                noMargin
              />
              <FormFieldViewText
                label="Created at"
                value={formatDate({
                  date: fromUnixTime(flowsIntegration.createdAt),
                  format: "statusDate",
                })}
                noMargin
              />
              <FormFieldViewText
                label="Updated at"
                value={formatDate({
                  date: fromUnixTime(flowsIntegration.updatedAt),
                  format: "statusDate",
                })}
                noMargin
              />
            </Box>
          ) : (
            <Typography variant="p-body3" tag="p">
              <Link
                href="https://spacelift.io/flows"
                target="_blank"
                rel="noopener noreferrer"
                inheritFont
                noEllipsis
              >
                Spacelift Flows
              </Link>{" "}
              automates your day-2 operations. Connect your Spacelift account to a new or existing
              Flows organization to switch between the two from the product menu.
            </Typography>
          )}
        </Card>
      </Box>
    </FlowsSettingsPageLayout>
  );
};

export default FlowsSettings;
